import React, { useState, useEffect } from "react";
import { IoIosTrash, IoMdDownload, IoIosCreate } from "react-icons/io";
import { AcceptIssueConfirmation, DeleteConfirmation, GetConfirmationByID, ConvertUnixTimestampToDateString, getInfo } from "../utilities/calls"
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import ActionMessage from "./ActionMessageModal";

const ConfirmationList = ({ confirmationsIDs = [], onDelete , onRefresh, sharedToken }) => {
  const [expanded, setExpanded] = useState(false);
  const [localConfirmationIDs, setIDs] = useState(confirmationsIDs)
  const [confirmationsData, setConfirmationsData] = useState([]);
  const [allowedDelete, setAllowedDelete] = useState({});
  const [modal, setModal] = useState({ show: false, message: "" });
  const [IDNavigate, setIDNavigate] = useState('')

  const navigate = useNavigate();

  useEffect(() => {
	Promise.all(
        localConfirmationIDs.map(async (el) => {
            try {
                return await GetConfirmationByID(el);
            } catch (err) {
                console.error("Error fetching confirmation:", err);
            }
        })
    )
    .then((contents) => {
        setConfirmationsData([]);
	    	contents.map((el) => {
			if (el) {
		        let newrow = {}
		        newrow.id = el.ID
				let jrnentity = el.FromJRN.split(":", 3)
		        newrow.partyType = jrnentity[1] === "serviceprovider" ? "Service Provider" : (jrnentity[1] === "beneficiary" ? "Beneficiary" : "Individual");
		        newrow.partyID = jrnentity[2];
				newrow.Link = newrow.partyType === "Service Provider" ? `/AddServiceProviderProfile/${newrow.partyID}` : (newrow.partyType === "Beneficiary" ? `/AddBeneficiaryProfile/${newrow.partyID}`: '' );
				newrow.date = el.createdAt
		        newrow.Type = el.Type
				newrow.ToJRN = el.ToJRN
		        setConfirmationsData(confirmationsData => [...confirmationsData, newrow]);
				filterDelete(newrow.id);
			}
        });
    })
    .catch((e) => {
        console.log(e);
        setModal({ show: true, message: `Can not fetch Confirmations! ${e} `  })
    });
  }, [localConfirmationIDs]);

  const ToggleTable = () => {
	if (expanded) {
		setExpanded(false);
	} else {
		setExpanded(true);
	}
  };

  const handlerDelete = async (id) => {
      if (onDelete) {
    	    try {
    			let result = await onDelete(id);
			setIDs(localConfirmationIDs.filter(item => item !== id));
			onRefresh();
		} catch (err) {
                console.error("Error deleting confirmation:", err);
                setModal({ show: true, message: `Can not Delete Confirmation! ${err} `  })
        }		
	  }
  };

  const filterDelete = (id) => {
	DeleteConfirmation(id, true).then((resp) => {
		setAllowedDelete((prev) => ({ 
        ...prev, 
        [id]: true 
      }));	
	}).catch ( (err) => {
		setAllowedDelete(({ [id]: _, ...rest }) => rest);
	});
  };

  const isIssuedToMe = (id) => {
		const shortlisted = confirmationsData.find( conf => conf.id === id)
		
		if (shortlisted) {
			let userid = getInfo("UserID")
			let individualid = getInfo("IndividualID")
			return (shortlisted.Type === "Issued" && (shortlisted.ToJRN === `jrn:user:${userid}` || shortlisted.ToJRN === `jrn:individual:${individualid}` ))
		}
		return false
  };

  const handlerAccept = async (id) => {
    
	console.log(id)
    const shortlisted = confirmationsData.find( conf => conf.id === id)
	if (shortlisted) {
        console.log(shortlisted)
        let rst = await AcceptIssueConfirmation(id, sharedToken)
        console.log(rst)
        setIDNavigate(rst.ID);
        setModal({ show: true, message: "Now Document is owned by you and can be found in Documents!"  });

    }
  };

  const donehere = () => {
    setModal({ show: false });
    onRefresh();
    if (IDNavigate !== '') {
        navigate(`/documentdetails/${IDNavigate}`)
        window.location.reload();
    } 
  };

  return (
	<>
	 {
		<button
	      onClick={ToggleTable}
	      className="flex items-center gap-2 text-orange-400 hover:text-blue-300 transition"
	    >
	      <IoMdDownload className="text-lg" />
	      <span>Show Confirmations</span>
	    </button>
	}
    { expanded ? <div className="w-full overflow-hidden rounded-xl border border-gray-200">
     <div className="overflow-x-auto">
      <table className="min-w-full">
        <thead className="bg-gray-100">
          <tr className="text-left text-sm font-semibold text-gray-600">
            <th className="px-4 py-2">Confirmation ID</th>
            <th className="px-4 py-2">Confirming Party</th>
            <th className="px-4 py-2">Date</th>
            <th className="px-4 py-2">Type</th>
            <th className="px-4 py-2 text-right">Action</th>
          </tr>
        </thead>

        <tbody>
          {confirmationsData.length === 0 ? (
            <tr>
              <td
                colSpan="4"
                className="text-center px-4 py-4 text-gray-500"
              >
                No confirmations available
              </td>
            </tr>
          ) : (
            confirmationsData.map((item) => (
              <tr
                key={item.id}
                className="border-t hover:bg-gray-950 transition"
              >
                <td className="px-4 py-2">{item.id}</td>
                <td className="px-4 py-2">{item.partyType === "Individual" ? (item.partyID === getInfo("IndividualID") ? "Current User": "Some Person") :<Link to={item.Link} state={{previousPage: '' }}>{item.partyType}-{item.partyID}</Link> }</td>
                <td className="px-4 py-2">
                  {dayjs(ConvertUnixTimestampToDateString(item.date)).format("MMM D, YYYY")}
                </td>
                <td className="px-4 py-2">{item.Type}</td>
                <td className="px-4 py-2 text-right">
                  <div className="flex justify-end gap-2">
				    {allowedDelete[item.id] && (
				      <button
				        id={`delete_${item.id}`}
				        className="text-red-500 hover:text-red-800 transition transition-transform duration-200 hover:scale-150"
				        title="Delete"
				        onClick={(e) => {
				          if (e.currentTarget.id === `delete_${item.id}`) {
				            handlerDelete(item.id);
				          }
				        }}
				      >
				        <IoIosTrash size={18} />
				      </button>
				    )}
				    { sharedToken && isIssuedToMe(item.id) ? (
				      <button
				        id={`Accept_${item.id}`}
				        className="text-blue-500 hover:text-blue-800 transition transition-transform duration-200 hover:scale-150"
				        title="Accept"
				        onClick={() => handlerAccept(item.id)}
				      >
				        <IoIosCreate size={18} />
				      </button>
				    ) : <></> }
				  </div>
				</td>                
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
       <>
		 {modal.show && (
          <ActionMessage isOpen={modal.show} onClose={()=> {donehere()}} message={modal.message} />
		  )
          }
       </>
       </div> : <></>
    }
    </>
  );
};

export default ConfirmationList;